import React from "react";
import {
    SupervisedUserCircleOutlined,
    Diversity3,
    AssessmentOutlined,
    GroupsOutlined,
    AssuredWorkloadOutlined,
    VideoLibraryOutlined,
    DownloadOutlined,
    WorkspacePremiumOutlined,
    QueryStats,
    AdminPanelSettingsOutlined,
    Inventory2Outlined,
    QuizOutlined,
    PhotoCamera,
    FaceOutlined,
} from "@mui/icons-material";
import { SystemContext } from "@Constants";
import { isDevelopment } from "@Utils";
import SessionManager from "@Core/session";

interface ISidebarMenuDetails {
    capability?: string;
    contextId?: number;
    icon: JSX.Element;
    path: string;
    text: string;
    key?: string; // Todo: start adding key to the menu items
}

/*
 * Main menu items
 *
 */
export const getSidebarMenu = (userId: string): ISidebarMenuDetails[] => {
    const roleGroups = SessionManager.getServiceUser()?.roleGroups ?? [];

    const list = [
        {
            text: "Profile",
            icon: <SupervisedUserCircleOutlined />,
            path: "/",
        },
        {
            text: "Activity",
            icon: <QueryStats />,
            path: "/activity?user=" + userId,
        },
        {
            ...(roleGroups.includes("Admin") || roleGroups.includes("QuestionnaireWriter")
                ? {
                      text: "Questionnaires",
                      icon: <QuizOutlined />,
                      path: "/questionnaires",
                      key: "questionnaires",
                  }
                : null),
        },
        {
            text: "Connections",
            icon: <Diversity3 />,
            path: "/connections",
        },
        {
            text: "Assessments",
            icon: <AssessmentOutlined />,
            path: "/assessments",
        },
        {
            text: "Groups",
            icon: <GroupsOutlined />,
            path: "/groups",
        },
        {
            text: "Roles",
            icon: <AdminPanelSettingsOutlined />,
            path: "/roles",
            capability: "Role/Update",
            contextId: SystemContext,
        },
        {
            text: "Consumables",
            icon: <Inventory2Outlined />,
            path: "/edit-consumables",
            capability: "Consumable/Create",
            contextId: SystemContext,
        },
        {
            text: "Licenses",
            icon: <WorkspacePremiumOutlined />,
            path: "/licenses#licenses",
            capability: "License/Create",
            contextId: SystemContext,
        },

        {
            text: "Compliance",
            icon: <AssuredWorkloadOutlined />,
            path: "/compliance",
            capability: "Compliance/GetAll",
            contextId: SystemContext,
        },
        {
            ...(isDevelopment()
                ? {
                      text: "Video Library",
                      icon: <VideoLibraryOutlined />,
                      path: "/video-library",
                      contextId: SystemContext,
                  }
                : null),
        },
        {
            ...(isDevelopment()
                ? {
                      text: "Imaging",
                      icon: <PhotoCamera />,
                      path: "/imaging",
                  }
                : null),
        },
        {
            text: "Downloads",
            icon: <DownloadOutlined />,
            path: "/downloads",
            contextId: SystemContext,
        },
        {
            ...(isDevelopment()
                ? {
                      text: "Ai Assistant",
                      icon: <FaceOutlined />,
                      path: "/ai-assistant",
                      key: "ai-assistant",
                      contextId: SystemContext,
                  }
                : null),
        },
    ].filter((item) => item.path); // remove any empty items
    return list;
};
